import localeRedirect from './localePlugin';
localeRedirect();